const selectors = {
  component: "[data-language-switcher]",
};

const initComponent = (component) => {
  document.addEventListener("click", (e) => {
    if (!component.contains(e.target)) {
      component.removeAttribute("open");
    }
  });
};

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const components = document.querySelectorAll(selectors.component);
    components?.forEach(initComponent);
  },
  { once: true }
);
